import {
  ElementRef,
  Injectable,
  Renderer
} from '@angular/core';


export class SkyTextExpandAdapterService {

  constructor(private renderer: Renderer) { }

  public getContainerHeight(containerEl: ElementRef) {
    return containerEl.nativeElement.offsetHeight;
  }

  public setContainerHeight(containerEl: ElementRef, height: string) {
    this.renderer.setElementStyle(containerEl.nativeElement, 'max-height', height);
  }

  public setText(textEl: ElementRef, text: string) {
    textEl.nativeElement.textContent = text;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
